import { gql } from '@apollo/client';

export const GET_DELIVERY_TASKS = gql`
  query GetDeliveryTasks($filter: DeliveryTaskFilterInput, $pageRequest: DeliveryTaskPageRequestTypeInput) {
    getDeliveryTasks(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        routeHistoryId
        routeName
        originalDriverId
        driverAccountId
        pathPlanningTaskId
        areaId
        areaName
        warehouseId
        dspId
        taskDate
        status
        assignedParcels
        actualPickedUpParcels
        transferInParcels
        transferOutParcels
        estimatedDistanceKm
        estimatedDurationMinutes
        createdBy
        createdByName
        createdAt
        updatedAt
        sortingCode
        actualDriverName
        isGroupRow
        totalTasks
        totalAssignedParcels
        totalActualPickedUp
        children {
          id
          routeHistoryId
          routeName
          originalDriverId
          driverAccountId
          pathPlanningTaskId
          areaId
          areaName
          warehouseId
          dspId
          taskDate
          status
          assignedParcels
          actualPickedUpParcels
          transferInParcels
          transferOutParcels
          estimatedDistanceKm
          estimatedDurationMinutes
          createdBy
          createdByName
          createdAt
          updatedAt
          sortingCode
          actualDriverName
          __typename
        }
        __typename
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
      __typename
    }
  }
`;

export const GET_DELIVERY_TASK_DETAIL = gql`
  query GetDeliveryTaskDetail($taskId: Long!) {
    getDeliveryTaskDetail(taskId: $taskId) {
      id
      routeHistoryId
      routeName
      originalDriverId
      driverAccountId
      pathPlanningTaskId
      areaId
      areaName
      warehouseId
      dspId
      taskDate
      status
      assignedParcels
      actualPickedUpParcels
      transferInParcels
      transferOutParcels
      estimatedDistanceKm
      estimatedDurationMinutes
      createdBy
      createdAt
      updatedAt
      sortingCode
      originalDriverName
      actualDriverName
      taskHistory {
        id
        eventType
        dataJson
        createdAt
        description
        __typename
      }
      parcels {
        id
        trackingNo
        zipcode
        stop
        subStopNumber
        status
        pickupStatus
        deliveryAddress
        routeName
        recipientName
        recipientPhoneNumber
        recipientPhoneExtension
        deliverAt
        deliveryAttempts
        preDeliveredAt
        deliveredAt
        exceptionReasonCode
        markExceptionAt
        latitude
        longitude
        __typename
      }
      __typename
    }
  }
`;

// 获取异常字典多语言数据
export const GET_EXCEPTION_DICTIONARY_FOR_DELIVERY = gql`
  query ExceptionDictionaryQuery {
    getExceptionDictionaryForDelivery {
      exceptionReasonCode
      primaryType
      secondaryTypeZh
      secondaryTypeEn
      secondaryTypeEs
      actionDescription
      isUploadsImages
    }
  }
`;

// 获取所有异常字典（完整版，包含所有字段）
export const GET_ALL_EXCEPTION_DICTIONARIES_FULL = gql`
  query GetAllExceptionDictionariesFull {
    getAllExceptionDictionariesFull {
      exceptionReasonCode
      primaryType
      secondaryTypeZh
      secondaryTypeEn
      secondaryTypeEs
      actionDescription
      isUploadsImages
    }
  }
`;
